<template>
    <div class="identify-html-viewer bg-light">
        <div v-html="filteredResponse"></div>
    </div>
</template>

<script>
    import {isString} from '@config/utils'
    const regexpBody = /<body[^>]*>((.|[\n\r])*)<\/body>/im; ///^[\s\S]*<body>([\s\S]*)<\/body>[\s\S]*$/i;
    const regexpStyle = /(<style[\s\=\w\/\"]*>[^<]*<\/style>)/i;

    export default {
        name: 'HTMLViewer',
        mixins: [
        ],
        components: {

        },
        props: {
            response: {
                type: String,
                default: '',
            },
            layer: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {

            }
        },
        computed: {
            filteredResponse() {
                let response = this.response || '';
                // gets css rules from the response and removes which are related to body tag.
                let styleMatch = regexpStyle.exec(response);
                let style = styleMatch && styleMatch.length === 2 ? regexpStyle.exec(response)[1] : "";
                style = style.replace(/body+/gi, '');
                // gets feature info managing an eventually empty response
                // let content = isString(response) ? response.replace(regexpBody, '$1').trim() : response;// this.$sanitize
                let contentMatch = regexpBody.exec(response);
                let content = isString(response) ? (contentMatch && contentMatch.length > 0 ? contentMatch[0] : '') : response;
                return style + content;
            }
        },
    }

</script>

<style scoped lang="scss">

</style>